module.exports = __webpack_public_path__ + "img/camavibrando.d3c5d612.gif";